import { useRef, useState } from "react";
import { RenderMenuItemChildren, Typeahead, TypeaheadRef } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { axiosFunction } from "../../../../components/commonFunctions/axiosFunction"
import { v2ReactURL } from "../../../../utils/constant";
import { DialogComponent, InputField } from "../../../../components/common";
import { toastMessage } from "../../../../components/commonFunctions/ToasterMessage";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { productSchemaType } from "../ContactDetails";
import Select from "react-select";
import { selectInputStyle } from "../../../../utils/SelectInputStyles";
 import { SelectInstance } from "react-select";
interface ProductSearchTypeHeadProps {
  productData?: productSchemaType;
  fetchProductListDatatable: (startIndex: number, pageLength: number) => void;
}

interface selectedProductDataType {
  productVarientId: number;
  productId: number;
  name: string;
  varientName: string;
  mrp: number;
  sellingPrice: number;
  landingCost: number;
}

interface duplicateBarcodeDataType {
  value: string;
  label: string;
}
const ProductSearchTypeHead = ({ productData, fetchProductListDatatable } : ProductSearchTypeHeadProps) => {
  const productRef = useRef<TypeaheadRef | null>(null);
  const selectRef = useRef<SelectInstance<duplicateBarcodeDataType> | null>(null);
  const params = useParams();
  const multibarcode = useSelector(
      (state: any) =>
        state.contactGeneralDetails.multibarcode
    ) && useSelector(
      (state: any) =>
        state.contactGeneralDetails.multiduplicatebarcode
    );

  const [selectedProductData, setSelectedProductData] =
    useState<selectedProductDataType>({
      productVarientId: 0,
      productId: 0,
      name: "",
      varientName: "",
      mrp: 0,
      sellingPrice: 0,
      landingCost: 0,
    });
  const [productPriceDialog, setProductPriceDialog] = useState<boolean>(false);
  const [duplicateBarcode, setduplicateBarcode] = useState<boolean>(false);
  const [duplicateBarcodeData, setduplicateBarcodeData] = useState<Array<selectedProductDataType>>([]);
  const contactType = useSelector((state:any) => state.contactType);

  const getProductDetail = async (isBarcode:boolean, productvariantId:number, barcode:string) => {
    if (isBarcode) {
      const res = await axiosFunction(
        `${v2ReactURL}/product/barcode/json?barcode=${barcode}`,
        "GET"
      );

      if (res?.data?.message === "Add new Product") {
        toastMessage("This barcode is not available");
      } else if (res?.data?.status) {
        if (multibarcode && res?.data?.response.length > 1) {
          setduplicateBarcode(true);
          setduplicateBarcodeData(res?.data?.response);
        } else {
          setProductPriceDialog(!productPriceDialog);
          setSelectedProductData(res?.data?.response[0]);
        }
      }
    } else {
      const res = await axiosFunction(
        `${v2ReactURL}/product/sales/${productvariantId}/json`,
        "GET"
      );
     

      setProductPriceDialog(true);
      setSelectedProductData(res?.data?.response);
    }
    productRef?.current?.clear();

    // productRef.current && productRef.current.value = "";
  };
  
  const handleProductSelection = (value:any) => {
 
    
    if (value && value[0]) {
      getProductDetail(false, value[0].id, "");
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    const target = event.target as HTMLInputElement;
    const activeItem = productRef.current?.state?.activeItem;
    if (event.key === "Enter" && target.value !== "" && !activeItem) {
      getProductDetail(true, 0, target.value);
      productRef?.current?.clear();
    }
  };

  const renderMenuItemChildren: RenderMenuItemChildren = (option:any) => (
     
      <div style={{ fontWeight: 600 }}>{option.value}</div>
    );

  const { register, handleSubmit, reset } = useForm({
    defaultValues: {
      specific_price: "",
    },
  });

  const productPriceDialogContent = () => {
    return (
      <span
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <InputField
          labelName="Product Name"
          placeholder="Product Name"
          name="product_name"
          defaultValue={selectedProductData?.name + " " + (selectedProductData?.varientName ?? "")}
          register={register}
          disabled={true}
        />

        <InputField
          labelName="Landing Price"
          placeholder="Landing Price"
          register={register}
          name="landing_price"
          defaultValue={selectedProductData?.landingCost}
          disabled={true}
        />

        <InputField
          labelName="MRP Price"
          placeholder="MRP Price"
          register={register}
          defaultValue={selectedProductData?.mrp}
          name="mrp_price"
          disabled={true}
        />

        <InputField
          labelName="Selling Price"
          placeholder="Selling Price"
          defaultValue={selectedProductData?.sellingPrice}
          register={register}
          name="selling_price"
          disabled={true}
        />

        <InputField
          labelName="Customer Specific Price"
          placeholder="Customer Specific Price"
          register={register}
          name="specific_price"
          defaultValue={0}
          inputType="number"
        />
      </span>
    );
  };

    const productSelectDialogContent = () => {
      return (
        <span
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Select
            id="productSelect"
            placeholder={"Select Product"}
            styles={selectInputStyle}
            className="customSelect"
            options={duplicateBarcodeData.map(
              (item: selectedProductDataType) : duplicateBarcodeDataType => ({
                value: item.productId.toString(),
                label: item.name,
              })
            )}
            menuPortalTarget={document.body}
            ref={selectRef}
          />
        </span>
      );
    };

  const handleProductSelectionForDuplicate = () => {
     const selectedOption = selectRef.current?.getValue?.()[0];
     if (selectedOption) {
       const data =  duplicateBarcodeData.find((item: selectedProductDataType) => item.productId.toString() === selectedOption?.value);
       data && setSelectedProductData(data);
       setduplicateBarcode(!duplicateBarcode);
       setProductPriceDialog(!productPriceDialog)
     } 
  }
  const onSubmit = async (data: { specific_price: string; }) => {
    const res = await axiosFunction(
      `${v2ReactURL}/contact/${contactType}/saveprice/${
        params.contactId
      }?productVarientId=${selectedProductData?.productVarientId}&productId=${
        selectedProductData?.productId
      }&customerSpecificPrice=${data?.specific_price}`,
      "POST",
      null
    );
    if (res?.data?.status) {
      setProductPriceDialog(!productPriceDialog);
      fetchProductListDatatable(0, 15);
      toastMessage(res?.data?.response, "success");
    }
    reset();
  };
  return (
    <div style={{ width: "90%" }}>
      <Typeahead
        ref={productRef}
        autoFocus
        id="basic-typeahead-single"
        labelKey="value"
        onChange={handleProductSelection}
        options={productData || []}
        placeholder="Search Product..."
        // selected={selectedProduct}
        minLength={1}
        onKeyDown={handleKeyDown}
        renderMenuItemChildren={renderMenuItemChildren}
      />

      {productPriceDialog && (
        <DialogComponent
          handleClose={() => setProductPriceDialog(!productPriceDialog)}
          dialogTitle={"Product Detail"}
          openDialog={productPriceDialog}
          dialogContent={productPriceDialogContent()}
          handleSubmitBtn={handleSubmit(onSubmit)}
          disabledSubmitBtn={false}
          submitBtnStyle={""}
          submitBtnName="Add"
        />
      )}
      {duplicateBarcode && (
        <DialogComponent
          handleClose={() => setduplicateBarcode(!duplicateBarcode)}
          dialogTitle={"Select Product"}
          openDialog={duplicateBarcode}
          dialogContent={productSelectDialogContent()}
          handleSubmitBtn={handleProductSelectionForDuplicate}
          disabledSubmitBtn={false}
          submitBtnStyle={""}
          submitBtnName="Select"
        />
      )}
    </div>
  );
};

export default ProductSearchTypeHead;
